const guestViewProperty = (id) => {
  let token = window.location.href.split('token=')[1]
  window.open('/#/share-property/' + id + '?token=' + token)
}

export {guestViewProperty}
